import { createApp } from 'vue'
import App from './App.vue'
import Vue from 'vue'
const xms = require('./utils/xms').default
import router from './router'
import store from './store'
import '@/styles/public.scss'
// import ElementPlus from 'element-plus'
// Vue.use(ElementPlus)
import ElementUI from 'element-ui'
Vue.use(ElementUI)
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

Vue.component('VueSlider', VueSlider)
	
import directives from './utils/directives'
Vue.use(directives)
// 添加实例属性
Object.assign(Vue.prototype, {
  define: require('./utils/define'), // 常量
  xms, // 公共方法
})

Vue.config.P = false
new Vue({
    router,
    store,
    render:h =>h(App)
}).$mount('#app')
//createApp(App).mount('#app')
